<form [formGroup]="form" (ngSubmit)="save()">
    <h1 mat-dialog-title>Centro y fecha facturación</h1>
    <div mat-dialog-content>
        <mat-form-field class="full-control">
            <mat-select formControlName="invoicingCenter" placeholder="Centro" required>
                <mat-option *ngFor="let center of centers" [value]="center">
                    {{ center.Name }}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="f.invoicingCenter.errors &&
             f.invoicingCenter.errors.required">
                Seleccione un centro
            </mat-error>
        </mat-form-field>
        <mat-form-field>
            <input matInput formControlName="invoicingDate" #dateOrder [matDatepicker]="picker" placeholder="Fecha" required>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            <mat-error *ngIf="f.invoicingDate.errors &&
               f.invoicingDate.errors.required">
                Seleccione una fecha
            </mat-error>
        </mat-form-field>
    </div>
    <div class="clearfix">
        <div class="pull-right">
            <button mat-button type="submit">Aceptar</button>
            <button mat-button type="button" cdkFocusInitial (click)="onNoClick()">Cancelar</button>
        </div>
    </div>
</form>